import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import RadioButtons from "core/RadioButtons";
import Paypal from "core/PartnerIcons/Paypal";

import { PAYMENT_METHODS } from "./constants";

import { useCheckoutFormGeneralError } from "frontend/context/CheckoutContext";

let PaymentMethodRadioButtons = ({ className, setPaymentMethod }) => {
    const { setGeneralFormError } = useCheckoutFormGeneralError();

    return (
        <RadioButtons
            className={className}
            onClick={method => {
                setGeneralFormError("");
                setPaymentMethod(method);
            }}
            defaultCheckedValue={PAYMENT_METHODS.CREDIT_CARD}
            radioName="checkout-type"
            fieldsetTitle="Which payment method do you want to use?"
            options={[
                {
                    value: PAYMENT_METHODS.CREDIT_CARD,
                    text: "Credit Card",
                    ariaLabel: "Pay with credit card"
                },
                {
                    value: PAYMENT_METHODS.PAYPAL,
                    text: "PayPal",
                    ariaLabel: "Pay with PayPal",
                    img: Paypal
                }
            ]}
        />
    );
};

PaymentMethodRadioButtons.propTypes = {
    className: PropTypes.string,
    setPaymentMethod: PropTypes.func.isRequired
};

PaymentMethodRadioButtons = styled(PaymentMethodRadioButtons)``;
export default PaymentMethodRadioButtons;
